import { useContext } from 'react'
import { MyNotificationCountContext } from '../contexts/MyNotificationCount'

const useMyNotificationCount = () => {
   const data = useContext(MyNotificationCountContext)
   return data
}

export default useMyNotificationCount
